import Swiper from 'swiper/bundle';

$(function () {
    window.initSlider();
});


/**
 * Slider container element
 */
window.initSlider = function ($object = null){


    if (null === $object) {
        $object = $('.swiper')
    } else if (!$($object).is('swiper')) {
        $object = $($object).find('.swiper')
    }


    $object.each(function () {

        const $container = $(this).find('.swiper-container');

        const $prev = $(this).find('.slider-prev');
        const $next = $(this).find('.slider-next');
        const $pagination = $(this).find('.swiper-pagination');


        new Swiper($container[0], {
            loop: true,
            autoplay: {
              delay: 8000,
            },
            speed: 600,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: false,
            wrapperClass: 'swiper-wrapper',
            slideClass: 'swiper-slide',
            containerModifierClass: 'swiper-container-',
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            pagination: {
                el: $pagination[0],
                clickable: true,
            },

        });
    });

};
